export const LISTEN_TO_QUIZ = "LISTEN_TO_QUIZ";
export const LISTEN_TO_QUIZ_USERANSWER = "LISTEN_TO_QUIZ_USERANSWER";
